import React from 'react';

const LessonTitle: React.FC<{ courseTitle: string; lessonTitle: string }> = ({
  courseTitle,
  lessonTitle,
}) => {
  return (
    <div className="py-[15px] text-center px-[25px] relative flex flex-col">
      <h2 className="font-bold m-0 text-[18px] md:text-[20px]">{courseTitle}</h2>
      <h3 className="text-[14px] md:text-[16px] m-0">{lessonTitle}</h3>
    </div>
  );
};

export default LessonTitle;
